/* Boosted Engineering easter eggs:
   1. Click the logo 3 times quickly → boost gauge.
   2. Konami code (↑ ↑ ↓ ↓ ← → ← → B A) → BOOST MODE dyno sheet.
   Also: any link to #be-finder opens and focuses the vehicle finder. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TURBO_SOUND = 'https://cdn.shopify.com/s/files/1/0729/7541/7574/files/turbo_dose.mp3?v=1791865651';
  var NS = 'http://www.w3.org/2000/svg';

  var svgEl = function (tag, attrs) {
    var el = document.createElementNS(NS, tag);
    for (var k in attrs) { if (Object.prototype.hasOwnProperty.call(attrs, k)) { el.setAttribute(k, attrs[k]); } }
    return el;
  };
  var playTurbo = function () {
    try { var a = new Audio(TURBO_SOUND); a.volume = 0.55; var p = a.play(); if (p && p.catch) { p.catch(function () {}); } } catch (e) {}
  };

  /* ---------- Overlay helper ---------- */
  var openOverlay = function (cls, label, build, ms) {
    var old = document.querySelector('.be-egg');
    if (old) { old.remove(); }
    var wrap = document.createElement('div');
    wrap.className = 'be-egg ' + cls;
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-label', label);
    var card = document.createElement('div');
    card.className = 'be-egg__card';
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'be-egg__x';
    x.setAttribute('aria-label', 'Close');
    x.textContent = '×';
    card.appendChild(x);
    var closers = [];
    build(card, function (fn) { closers.push(fn); });
    wrap.appendChild(card);
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-in'); });
    var closed = false, t = null;
    var close = function () {
      if (closed) { return; }
      closed = true;
      clearTimeout(t);
      closers.forEach(function (fn) { try { fn(); } catch (e) {} });
      document.removeEventListener('keydown', onKey);
      wrap.classList.remove('is-in');
      setTimeout(function () { wrap.remove(); }, 300);
    };
    var onKey = function (e) { if (e.key === 'Escape') { close(); } };
    document.addEventListener('keydown', onKey);
    x.addEventListener('click', close);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) { close(); } });
    t = setTimeout(close, ms);
    x.focus({ preventScroll: true });
    return close;
  };

  /* ---------- 1. Boost gauge ---------- */
  var MIN = -15, MAX = 30, A0 = -135, A1 = 135;
  var ang = function (v) { return A0 + (v - MIN) / (MAX - MIN) * (A1 - A0); };
  var pt = function (cx, cy, r, a) { var rad = (a - 90) * Math.PI / 180; return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)]; };
  var arc = function (cx, cy, r, a0, a1) {
    var p0 = pt(cx, cy, r, a0), p1 = pt(cx, cy, r, a1);
    return 'M' + p0[0].toFixed(1) + ' ' + p0[1].toFixed(1) + ' A' + r + ' ' + r + ' 0 ' + (a1 - a0 > 180 ? 1 : 0) + ' 1 ' + p1[0].toFixed(1) + ' ' + p1[1].toFixed(1);
  };

  var openGauge = function () {
    playTurbo();
    openOverlay('be-egg--gauge', 'Boost gauge', function (card) {
      var s = svgEl('svg', { viewBox: '0 0 220 220', width: '220', height: '220', 'aria-hidden': 'true', class: 'be-egg__gauge' });
      s.appendChild(svgEl('circle', { cx: 110, cy: 110, r: 104, class: 'g-face' }));
      s.appendChild(svgEl('path', { d: arc(110, 110, 86, A0, ang(0)), class: 'g-vac' }));
      s.appendChild(svgEl('path', { d: arc(110, 110, 86, ang(0), ang(22)), class: 'g-arc' }));
      s.appendChild(svgEl('path', { d: arc(110, 110, 86, ang(22), A1), class: 'g-red' }));
      for (var v = MIN; v <= MAX; v += 5) {
        var a = ang(v), o = pt(110, 110, 78, a), i = pt(110, 110, v % 10 === 0 ? 66 : 71, a);
        s.appendChild(svgEl('line', { x1: o[0], y1: o[1], x2: i[0], y2: i[1], class: 'g-tick' }));
        if (v % 10 === 0) {
          var l = pt(110, 110, 54, a), tx = svgEl('text', { x: l[0], y: l[1] + 4, class: 'g-num' });
          tx.textContent = v;
          s.appendChild(tx);
        }
      }
      var unit = svgEl('text', { x: 110, y: 160, class: 'g-unit' }); unit.textContent = 'PSI'; s.appendChild(unit);
      var needle = svgEl('g', { class: 'g-needle' });
      needle.appendChild(svgEl('path', { d: 'M107 112 L110 28 L113 112 Z' }));
      needle.appendChild(svgEl('circle', { cx: 110, cy: 110, r: 9, class: 'g-hub' }));
      s.appendChild(needle);
      card.appendChild(s);
      var read = document.createElement('div');
      read.className = 'be-egg__read';
      read.textContent = '-12.0 psi';
      card.appendChild(read);
      var cap = document.createElement('div');
      cap.className = 'be-egg__cap';
      cap.textContent = 'Spooling…';
      card.appendChild(cap);

      var set = function (val) {
        needle.setAttribute('transform', 'rotate(' + ang(val).toFixed(2) + ' 110 110)');
        read.textContent = (val >= 0 ? '+' : '') + val.toFixed(1) + ' psi';
      };
      /* keyframes: [time ms, psi] */
      var K = [[0, -12], [350, -10], [1300, 29.2], [1550, 25.4], [1800, 26.6], [2300, 26], [2600, 26.4], [2900, -9], [3300, -11]];
      if (reduce) { set(26); cap.textContent = 'Full boost'; return; }
      var start = null;
      var ease = function (t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };
      var step = function (now) {
        if (!document.body.contains(s)) { return; }
        if (start === null) { start = now; }
        var t = now - start, val = K[K.length - 1][1];
        for (var k = 1; k < K.length; k++) {
          if (t <= K[k][0]) { var p = (t - K[k - 1][0]) / (K[k][0] - K[k - 1][0]); val = K[k - 1][1] + (K[k][1] - K[k - 1][1]) * ease(p); break; }
        }
        if (t > 1800 && t < 2600) { val += Math.sin(t / 22) * 0.35; }
        set(val);
        cap.textContent = t < 1300 ? 'Spooling…' : t < 2800 ? 'Full boost' : 'Pssshh…';
        if (t < K[K.length - 1][0]) { requestAnimationFrame(step); }
      };
      set(-12);
      requestAnimationFrame(step);
    }, 4200);
  };

  var logo = document.querySelector('.be-logo');
  if (logo) {
    var count = 0, timer = null;
    logo.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) { return; }
      e.preventDefault();
      count++;
      clearTimeout(timer);
      if (count >= 3) { count = 0; openGauge(); return; }
      timer = setTimeout(function () { var c = count; count = 0; if (c) { window.location.href = logo.href; } }, 350);
    });
  }

  /* ---------- 2. Konami code → dyno pull, synced to real dyno audio ---------- */
  var DYNO_SOUND = 'https://cdn.shopify.com/s/files/1/0729/7541/7574/files/boosted-dyno-pull.mp3?v=1792172830';
  var PULL_END = 7.5;            /* seconds into the clip where the pull ends */
  var RPM0 = 3000, RPM1 = 8500;  /* rpm sweep across the pull */
  var PEAK = 1023;

  var openDyno = function () {
    var audio = null;
    if (DYNO_SOUND.indexOf('http') === 0) { try { audio = new Audio(DYNO_SOUND); audio.volume = 0.8; audio.preload = 'auto'; } catch (e) { audio = null; } }
    openOverlay('be-egg--dyno', 'Boost mode enabled', function (card, onClose) {
      var h = document.createElement('div');
      h.className = 'be-egg__title';
      h.textContent = 'BOOST MODE ENABLED';
      card.appendChild(h);

      var W = 520, H = 260, L = 48, R = 16, T = 18, B = 34, YMAX = 1250;
      var rx = function (rpm) { return L + (rpm - RPM0) / (RPM1 - RPM0) * (W - L - R); };
      var hy = function (hp) { return T + (1 - hp / YMAX) * (H - T - B); };
      var raw = function (r) { var spool = 1 / (1 + Math.exp(-(r - 4700) / 520)); return spool * (1 - 0.000000014 * Math.pow(r - 7400, 2)) + Math.sin(r / 140) * 0.004; };
      var rawPeak = 0, peakRpm = RPM0;
      for (var q = RPM0; q <= RPM1; q += 10) { var v = raw(q); if (v > rawPeak) { rawPeak = v; peakRpm = q; } }
      var hpAt = function (r) { return Math.max(0, raw(r) / rawPeak * PEAK); };
      var nmAt = function (r) { return hpAt(r) * 7121 / r; };
      var tqPeak = 0, tqRpm = RPM0;
      for (var q2 = RPM0; q2 <= RPM1; q2 += 10) { var tv = nmAt(q2); if (tv > tqPeak) { tqPeak = tv; tqRpm = q2; } }
      tqPeak = Math.round(tqPeak);
      var stock = function (r) { return 205 * (1 - Math.exp(-(r - 1400) / 2100)) * (r > 6900 ? 1 - (r - 6900) / 3000 : 1); };

      var s = svgEl('svg', { viewBox: '0 0 ' + W + ' ' + H, class: 'be-egg__dyno', 'aria-hidden': 'true' });
      for (var g = 0; g <= 1250; g += 250) {
        s.appendChild(svgEl('line', { x1: L, x2: W - R, y1: hy(g), y2: hy(g), class: 'd-grid' }));
        var ty = svgEl('text', { x: L - 8, y: hy(g) + 4, class: 'd-lab d-lab--y' }); ty.textContent = g; s.appendChild(ty);
      }
      for (var r = 3000; r <= 8000; r += 1000) {
        var tx = svgEl('text', { x: rx(r), y: H - 12, class: 'd-lab' }); tx.textContent = (r / 1000) + 'k'; s.appendChild(tx);
      }
      var rl = svgEl('text', { x: W - R, y: H - 12, class: 'd-lab d-lab--end' }); rl.textContent = 'RPM'; s.appendChild(rl);
      var sd = '';
      for (var r2 = RPM0; r2 <= RPM1; r2 += 100) { sd += (sd ? ' L' : 'M') + rx(r2).toFixed(1) + ' ' + hy(stock(r2)).toFixed(1); }
      s.appendChild(svgEl('path', { d: sd, class: 'd-stock' }));
      var tcurve = svgEl('path', { d: '', class: 'd-torque' });
      s.appendChild(tcurve);
      var curve = svgEl('path', { d: '', class: 'd-boost' });
      s.appendChild(curve);
      var thead = svgEl('circle', { r: 4, class: 'd-thead', cx: rx(RPM0), cy: hy(0) });
      s.appendChild(thead);
      var head = svgEl('circle', { r: 5, class: 'd-head', cx: rx(RPM0), cy: hy(0) });
      s.appendChild(head);
      var pk = svgEl('g', { class: 'd-peak' });
      pk.appendChild(svgEl('circle', { cx: rx(peakRpm), cy: hy(PEAK), r: 6 }));
      var pkT = svgEl('text', { x: rx(peakRpm), y: hy(PEAK) - 12 }); pkT.textContent = PEAK + ' HP'; pk.appendChild(pkT);
      s.appendChild(pk);
      var tk = svgEl('g', { class: 'd-peak d-peak--tq' });
      tk.appendChild(svgEl('circle', { cx: rx(tqRpm), cy: hy(tqPeak), r: 5 }));
      var tkT = svgEl('text', { x: rx(tqRpm), y: hy(tqPeak) - 12 }); tkT.textContent = tqPeak.toLocaleString('en-AU') + ' Nm'; tk.appendChild(tkT);
      s.appendChild(tk);
      card.appendChild(s);

      var live = document.createElement('div');
      live.className = 'be-egg__live';
      var liveR = document.createElement('span'), liveH = document.createElement('b'), liveT = document.createElement('b');
      liveT.className = 'is-tq';
      live.appendChild(liveR); live.appendChild(liveH); live.appendChild(liveT);
      card.appendChild(live);

      var legend = document.createElement('div');
      legend.className = 'be-egg__legend';
      legend.innerHTML = '<span><i class="k-stock"></i>Stock</span><span><i class="k-boost"></i>Power (hp)</span><span><i class="k-tq"></i>Torque (Nm)</span>';
      card.appendChild(legend);

      var res = document.createElement('div');
      res.className = 'be-egg__result is-wait';
      res.textContent = PEAK.toLocaleString('en-AU') + ' HP  ·  ' + tqPeak.toLocaleString('en-AU') + ' Nm';
      card.appendChild(res);

      var cta = document.createElement('a');
      cta.className = 'be-btn be-btn--red be-egg__cta';
      cta.href = '/collections/turbo-kits';
      cta.textContent = 'Make it real: shop turbo kits';
      card.appendChild(cta);

      var draw = function (t) {
        var p = Math.max(0, Math.min(1, t / PULL_END));
        var rpmNow = RPM0 + (RPM1 - RPM0) * p, d = '', td = '';
        for (var r3 = RPM0; r3 <= rpmNow; r3 += 50) {
          d += (d ? ' L' : 'M') + rx(r3).toFixed(1) + ' ' + hy(hpAt(r3)).toFixed(1);
          td += (td ? ' L' : 'M') + rx(r3).toFixed(1) + ' ' + hy(nmAt(r3)).toFixed(1);
        }
        d += (d ? ' L' : 'M') + rx(rpmNow).toFixed(1) + ' ' + hy(hpAt(rpmNow)).toFixed(1);
        td += (td ? ' L' : 'M') + rx(rpmNow).toFixed(1) + ' ' + hy(nmAt(rpmNow)).toFixed(1);
        curve.setAttribute('d', d);
        tcurve.setAttribute('d', td);
        thead.setAttribute('cx', rx(rpmNow).toFixed(1));
        thead.setAttribute('cy', hy(nmAt(rpmNow)).toFixed(1));
        liveT.textContent = Math.round(nmAt(rpmNow)).toLocaleString('en-AU') + ' Nm';
        head.setAttribute('cx', rx(rpmNow).toFixed(1));
        head.setAttribute('cy', hy(hpAt(rpmNow)).toFixed(1));
        liveR.textContent = Math.round(rpmNow).toLocaleString('en-AU') + ' rpm';
        liveH.textContent = Math.round(hpAt(rpmNow)).toLocaleString('en-AU') + ' hp';
        if (p >= 1) { pk.classList.add('is-on'); tk.classList.add('is-on'); res.classList.remove('is-wait'); head.classList.add('is-off'); thead.classList.add('is-off'); }
      };

      if (reduce) { draw(PULL_END); }
      else {
        var t0 = null, stopped = false, useAudio = false;
        var tick = function (now) {
          if (stopped || !document.body.contains(s)) { return; }
          if (t0 === null) { t0 = now; }
          var t = useAudio && audio && !audio.paused ? audio.currentTime : (now - t0) / 1000;
          draw(t);
          if (t < PULL_END) { requestAnimationFrame(tick); }
        };
        draw(0);
        if (audio) {
          var pr = audio.play();
          if (pr && pr.then) { pr.then(function () { useAudio = true; }).catch(function () { useAudio = false; }); } else { useAudio = true; }
        }
        requestAnimationFrame(tick);
        onClose(function () { stopped = true; });
      }
      onClose(function () { if (audio) { try { audio.pause(); } catch (e) {} } });
      document.documentElement.classList.add('be-boostmode');
      onClose(function () { document.documentElement.classList.remove('be-boostmode'); });
    }, 12500);
  };

  var SEQ = ['arrowup', 'arrowup', 'arrowdown', 'arrowdown', 'arrowleft', 'arrowright', 'arrowleft', 'arrowright', 'b', 'a'];
  var pos = 0;
  document.addEventListener('keydown', function (e) {
    var tg = e.target;
    if (tg && (tg.tagName === 'INPUT' || tg.tagName === 'TEXTAREA' || tg.tagName === 'SELECT' || tg.isContentEditable)) { return; }
    var k = (e.key || '').toLowerCase();
    if (k === SEQ[pos]) { pos++; if (pos === SEQ.length) { pos = 0; openDyno(); } }
    else { pos = k === SEQ[0] ? 1 : 0; }
  });

  /* ---------- Links to the vehicle finder open it ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href="#be-finder"]') : null;
    if (!a) { return; }
    var f = document.getElementById('be-finder');
    if (!f) { return; }
    e.preventDefault();
    f.classList.add('is-open');
    var b = f.querySelector('[data-be-finder-open]');
    if (b) { b.setAttribute('aria-expanded', 'true'); }
    f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var sel = f.querySelector('select');
    if (sel) { setTimeout(function () { sel.focus({ preventScroll: true }); }, 400); }
  });
})();
